import React, { memo } from 'react';
import styles from './Education.module.scss';

const Education = memo(
    ({ educationList, onEducationChangeHandler, onDeleteEducationHandler }) => {
        return (
            <ul className="list-unstyled">
                {educationList.map((education, educationIndex) => (
                    <li
                        key={educationIndex}
                        className={`${styles.ListItem} row`}>
                        <div className="col-12 form-group">
                            <input
                                type="text"
                                placeholder="School"
                                value={education.organization}
                                onChange={(event) =>
                                    onEducationChangeHandler(
                                        event,
                                        educationIndex,
                                        'organization'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkPosition} form-control`}
                            />
                        </div>
                        <div className="col-12 form-group form-group--name">
                            <input
                                type="text"
                                placeholder="Program"
                                value={education.program}
                                onChange={(event) =>
                                    onEducationChangeHandler(
                                        event,
                                        educationIndex,
                                        'program'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkCompanyName} form-control`}
                            />
                        </div>
                        <div className="col-auto form-group--startdate form-group">
                            <input
                                type="text"
                                name="workStartDate"
                                placeholder="2013-01"
                                value={education.startDate}
                                onChange={(event) =>
                                    onEducationChangeHandler(
                                        event,
                                        educationIndex,
                                        'startDate'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkDate} form-control`}
                                style={{
                                    width: '100px'
                                }}
                            />
                        </div>
                        <div className="col-auto form-group form-group--enddate">
                            <input
                                type="text"
                                name="workEndDate"
                                placeholder="2014-01"
                                value={education.endDate}
                                onChange={(event) =>
                                    onEducationChangeHandler(
                                        event,
                                        educationIndex,
                                        'endDate'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkDate} form-control`}
                                style={{
                                    width: '100px'
                                }}
                            />
                        </div>
                        <div className="col-auto">
                            <button
                                onClick={() =>
                                    onDeleteEducationHandler(educationIndex)
                                }
                                className={`${styles.DeleteListItem} btn btn-outline-danger`}>
                                ×
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        );
    }
);

export default Education;
